import { ref, readonly } from 'vue';
import { get, ENDPOINTS } from '@/api/mainApi';
import store from '@/store';
import { DonationCause } from '@/interfaces/organizationgroup/donationCause';

export function useDonationCauses() {
  const loading = ref(false);
  const error = ref<string | null>(null);

  const getDonationCauseById = async (id: number): Promise<DonationCause> => {
    loading.value = true;
    error.value = null;

    try {
      const cause = await get(`${ENDPOINTS.DONATION_CAUSES}/${id}`);
      return cause;
    } catch (err) {
      error.value = 'Failed to fetch donation cause';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  const getDonationCausesByIds = async (ids: number[]): Promise<DonationCause[]> => {
    loading.value = true;
    error.value = null;

    try {
      const causes = await get(`${ENDPOINTS.DONATION_CAUSES}?ids=${ids.join(',')}`);
      return causes;
    } catch (err) {
      error.value = 'Failed to fetch donation causes';
      store.commit('setSnackbar', { active: true, color: 'error', text: error.value });
      throw err;
    } finally {
      loading.value = false;
    }
  };

  return {
    loading: readonly(loading),
    error: readonly(error),
    getDonationCauseById,
    getDonationCausesByIds,
  };
}
